import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ZigStub } from '@zignaly-open/ui';

const CriticalError: React.FC = () => {
  const { t } = useTranslation(['common', 'error']);
  const [online, setOnline] = useState(navigator.onLine);
  const [isRefreshingAfterOffline, setIsRefreshingAfterOffline] =
    useState(false);

  useEffect(() => {
    const handleBecomeOnline = () => {
      setOnline(true);
      setIsRefreshingAfterOffline(true);
      window.location.reload();
    };
    const handleBecomeOffline = () => {
      setOnline(false);
    };

    window.addEventListener('online', handleBecomeOnline);
    window.addEventListener('offline', handleBecomeOffline);

    return () => {
      window.removeEventListener('online', handleBecomeOnline);
      window.removeEventListener('offline', handleBecomeOffline);
    };
  }, []);

  return online && !isRefreshingAfterOffline ? (
    <ZigStub
      title={t('critical-error.title')}
      description={t('critical-error.description')}
    />
  ) : (
    <ZigStub
      title={t('error:offline.title')}
      description={t('error:offline.description')}
    />
  );
};

export default CriticalError;
